import React from "react";
import "./Footer.css";

const Footer = () => {
  return <div className="footer">Created by Hirushi Nethmini</div>;
};

export default Footer;
